import React from 'react';
import BaseSimplePage from "../BaseSimplePage/BaseSimplePage";
import SpheresItemForm from "./SpheresItemForm";

const SpheresPage = ({isAddSubMode}) => {

    return (
        <BaseSimplePage
            isAddSubMode={isAddSubMode}
            modeApiName1="sphere"
            modeApiName2="spheres"
            ItemFormComponent={SpheresItemForm}
        />
    );
};

export default SpheresPage;